import React from 'react';

const PageHeader = ({ title, subtitle, action, children, className = '' }) => (
  <div className={`flex flex-wrap items-start justify-between gap-4 mb-6 ${className}`}>
    <div className="min-w-0">
      <h1 className="text-[1.625rem] font-bold text-neutral-900 leading-tight tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1.5 text-sm text-neutral-500 max-w-2xl">{subtitle}</p>}
      {children}
    </div>
    {action && <div className="flex items-center gap-2 flex-shrink-0">{action}</div>}
  </div>
);

export default PageHeader;
